import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { GetEnumsResponse } from "../models/enum.model";
import { ApiBaseUrl, DropDownUrl } from "../config/config";
import {
  getCategoriesResponse,
  IDropdownRequest,
  IDropdownResponse,
} from "../models/dropdown.model";
import {
  AllStoresAndBranchesRequest,
  AllStoresAndBranchesResponse,
} from "../models/supplierUserBarnch.model";

export const getAllBranches = async (data: {
  title?: string;
}): Promise<GetEnumsResponse[]> => {
  return await Axios.post<ApiResultModel<GetEnumsResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllBranches",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const getCategories = (): Promise<ApiResultModel<
  getCategoriesResponse[]
>> => {
  return Axios.post<ApiResultModel<getCategoriesResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetCategories"
  ).then((result) => {
    return result.data;
  });
};

export const GetAllStores = (
  data: IDropdownRequest
): Promise<ApiResultModel<IDropdownResponse[]>> => {
  return Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllStores",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetAllIbanNumbers = (
  data: IDropdownRequest
): Promise<ApiResultModel<IDropdownResponse[]>> => {
  return Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllIbanNumbers",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetCities = (
  data: IDropdownRequest
): Promise<ApiResultModel<IDropdownResponse[]>> => {
  return Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetCities",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetAllUsers = (
  data: IDropdownRequest
): Promise<ApiResultModel<IDropdownResponse[]>> => {
  return Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllUsers",
    data
  ).then((result) => {
    return result.data;
  });
};
export const GetFinancialSuppliers = (
  data: IDropdownRequest
): Promise<IDropdownResponse[]> => {
  return Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetFinancialSuppliers",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetAllStoresAndBranches = async (
  data: AllStoresAndBranchesRequest
): Promise<AllStoresAndBranchesResponse[]> => {
  return await Axios.post<ApiResultModel<AllStoresAndBranchesResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllStoresAndBranches",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const getAllBanks = async (data: {
  title?: string;
}): Promise<IDropdownResponse[]> => {
  return await Axios.post<ApiResultModel<IDropdownResponse[]>>(
    ApiBaseUrl + DropDownUrl + "/GetAllBanks",
    data
  ).then((result) => {
    return result.data.data;
  });
};
